import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      VIEW_ALL_ORDERS: "Se alle tidligere bestillinger",
      ABOUT_DELIVERY_DELIVERED: "Alt om leveransen som ble levert",
      ABOUT_DELIVERY_ON_THE_WAY: "Alt om bestillingen som kommer",
      YOUR_ORDER_WEEK: "Din bestilling uke",
      MEALS: "middager",
      PORTIONS: "pers",
      SHORT_DATE_FORMAT: "d. MMMM",
      STANDALONE_PRODUCTS: "Dagligvarer",
      DINNERS: "Middager",
      REPORT_PROBLEMS_OR_MISSING_ITEMS: "Rapporter feil/mangler",
      REFER_A_FRIEND: "Verv en venn",
    },
    se: {
      VIEW_ALL_ORDERS: "Visa alla tidigare beställningar",
      ABOUT_DELIVERY_DELIVERED: "Allt om leveransen som kom",
      ABOUT_DELIVERY_ON_THE_WAY: "Allt om leveransen som kommer",
      YOUR_ORDER_WEEK: "Din beställning vecka",
      MEALS: "middagar",
      PORTIONS: "pers",
      SHORT_DATE_FORMAT: "d MMMM",
      STANDALONE_PRODUCTS: "Livsmedel",
      DINNERS: "Middagar",
      REPORT_PROBLEMS_OR_MISSING_ITEMS: "Rapportera fel/saknad vara",
      REFER_A_FRIEND: "Värva en vän",
    },
    dk: {
      VIEW_ALL_ORDERS: "Se alle tidligere bestillinger",
      ABOUT_DELIVERY_DELIVERED: "Alt om din tidligere levering",
      ABOUT_DELIVERY_ON_THE_WAY: "Alt om leveringen der kommer",
      YOUR_ORDER_WEEK: "Din bestilling uge",
      MEALS: "retter",
      PORTIONS: "pers",
      SHORT_DATE_FORMAT: "d. MMMM",
      STANDALONE_PRODUCTS: "Specialvarer",
      DINNERS: "Retter",
      REPORT_PROBLEMS_OR_MISSING_ITEMS: "Rapporter fejl/manglende varer",
      REFER_A_FRIEND: "Anbefal til en ven",
    },
  } as const
)[language];
